import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule, IonicPageModule } from "ionic-angular";
import { ComponentsModule } from "../../components/components.module";
import { TrainingListModule } from "../../components/training-list/training-list.module";
import { TrainingsPage } from "./trainings";

@NgModule({
  declarations: [TrainingsPage],
  imports: [
    IonicModule,
    IonicPageModule.forChild(TrainingsPage),
    TranslateModule.forChild(),
    ComponentsModule,
    TrainingListModule,
  ],
  exports: [TrainingsPage],
})
export class TrainingsPageModule {}



// WEBPACK FOOTER //
// ./src/app/pages/trainings/trainings.module.ts